<app-loading [type]="'spinner'" [showLoading]="showLoading"></app-loading>
<div class="rectangle-header">
    <div class="event-registerd"> {{ 'EN4_451.TRANSLATION' | translate }}</div>
    <div class="event-router"> <a href=""> {{ 'EN4_452.TRANSLATION' | translate }} </a><a href="">
            {{ 'EN4_453.TRANSLATION' | translate }} </a>><a href=".../#/taxaCorretagem">
            {{ 'EN4_454.TRANSLATION' | translate }} </a></div>
    <div class="event-router-text">
        <span class="example-spacer"></span>
        <span>{{ 'EN4_455.TRANSLATION' | translate }}</span></div>
    <!-- <div class="event-schedlue"><span class="event-schedlue-span" >  {{ 'EN4_455.TRANSLATION' | translate }} </span></div> -->
</div>
<div class="rectangle-center">
    <mat-accordion>
        <!-- <mat-expansion-panel (afterExpand)="loadStatusCombobox();"> -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="filter-title text-bold">
                    {{ 'EN4_456.TRANSLATION' | translate }}
                </div>
            </mat-expansion-panel-header>
            <form [formGroup]="filterForm" class="filterForm">
                <div class="filter-container">
                    <mat-form-field>
                        <mat-label> {{ 'EN4_457.TRANSLATION' | translate }}</mat-label>
                        <input matInput type="text" id="brokerage-fee-carteira-filter-field" formControlName="carteira">
                    </mat-form-field>
                    <mat-form-field class="date-brokerage-fee">
                        <mat-label>{{ 'EN4_458.TRANSLATION' | translate }}</mat-label>
                        <input matInput id="brokerage-fee-dtStart-filter-field" formControlName="data_inicio_negociacao"
                            [matDatepicker]="pickerStartDate" [min]="minDate" maxlength="10">
                        <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
                        <mat-datepicker #pickerStartDate></mat-datepicker>
                        <mat-error *ngIf="filterForm.errors?.startEndInvalid">{{ 'EN4_459.TRANSLATION' | translate }}
                        </mat-error>
                        <mat-error *ngIf="filterForm.errors?.emptyStartDate">{{ 'EN4_460.TRANSLATION' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="date-brokerage-fee">
                        <mat-label>{{ 'EN4_461.TRANSLATION' | translate }}</mat-label>
                        <input matInput id="brokerage-fee-dtEnd-filter-field" formControlName="data_fim_negociacao"
                            [matDatepicker]="pickerEndDate" [min]="minDate" maxlength="10">
                        <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                        <mat-datepicker #pickerEndDate></mat-datepicker>
                        <mat-error *ngIf="filterForm.errors?.emptyEndDate">{{ 'EN4_462.TRANSLATION' | translate }}
                        </mat-error>
                        <mat-error *ngIf="filterForm.errors?.MaxRange">{{ 'EN4_463.TRANSLATION' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>{{ 'EN4_464.TRANSLATION' | translate }}</mat-label>
                        <mat-select id="brokerage-fee-modalidade-filter-field" formControlName="modalidade" multiple>
                            <mat-option *ngFor="let comboModality of typesModality" [value]="comboModality.value">
                                {{comboModality.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="filter-container">
                    <mat-form-field>
                        <mat-label>{{ 'EN4_465.TRANSLATION' | translate }}</mat-label>
                        <input matInput type="text" id="brokerage-fee-corretora-filter-field"
                            formControlName="corretora">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>{{ 'EN4_466.TRANSLATION' | translate }}</mat-label>
                        <input matInput type="text" id="brokerage-fee-papel-filter-field" formControlName="papel">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>{{ 'EN4_467.TRANSLATION' | translate }}</mat-label>
                        <mat-select id="brokerage-fee-status-filter-field" formControlName="status" multiple>
                            <mat-option *ngFor="let comboStatus of typeStatus"
                                [value]="comboStatus.codigo_status_taxa_corretagem">
                                {{comboStatus.nome_status_taxa_corretagem}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="filter-container align-right">
                    <button class="btn outline mt-10-sm cursor-pointer" type="button" (click)="clearFilter();">
                        <span class="text-blue text-bold">{{ 'EN4_468.TRANSLATION' | translate }}</span>
                    </button>
                    <button class="btn orange ml-10-lg mt-10-sm cursor-pointer" type="button" (click)="applyFilter();">
                        <span> {{ 'EN4_469.TRANSLATION' | translate }}</span>
                    </button>
                </div>
            </form>
        </mat-expansion-panel>
    </mat-accordion>
</div>
<div class="rectangle-center">
    <div class="example-container mat-elevation-z8">
        <mat-toolbar>
            <span class="demandas text-bold">{{ 'EN4_470.TRANSLATION' | translate }}</span>
            <span class="example-spacer"></span>
            <span class="exportTxt">{{ 'EN4_471.TRANSLATION' | translate }}</span>
            <button mat-raised-button class="button-event" type="button" (click)="downloadPDF()">
                <span class="text-blue text-bold">PDF</span>
            </button>
            <button mat-raised-button class="button-event" type="button" (click)="downloadExcel()">
                <span class="text-blue text-bold">EXCEL</span>
            </button>
            <span class="example-spacer2"></span>
            <button mat-raised-button class="button-event-orange" (click)="applyFees();">
                <span class="text-orange">{{ 'EN4_472.TRANSLATION' | translate }}</span>
            </button>
        </mat-toolbar>

        <div class="example-container mat-elevation-z8">
            <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8">

                <ng-container matColumnDef="carteira">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>{{ 'EN4_473.TRANSLATION' | translate }}
                    </th>
                    <td class="columns-result" style="text-align: lefth;" mat-cell *matCellDef="let element"> {{element.carteira}} </td>
                </ng-container>

                <ng-container matColumnDef="operacao">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>{{ 'EN4_330.TRANSLATION' | translate }}
                    </th>
                    <td class="columns-result" style="text-align: center;" mat-cell *matCellDef="let element"> {{element.operacao}} </td>
                </ng-container>

                <ng-container matColumnDef="contrato_emprestimo_acao">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>{{ 'EN4_474.TRANSLATION' | translate }}
                    </th>
                    <td class="columns-result" style="text-align: center;" mat-cell *matCellDef="let element"> {{element.contrato_emprestimo_acao}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="corretora">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>{{ 'EN4_465.TRANSLATION' | translate }}
                    </th>
                    <td class="columns-result" mat-cell *matCellDef="let element"
                        style="text-align: center; vertical-align: middle;"> {{element.corretora}} </td>
                </ng-container>

                <ng-container matColumnDef="modalidade">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>{{ 'EN4_464.TRANSLATION' | translate }}
                    </th>
                    <td class="columns-result" mat-cell *matCellDef="let element"
                        style="text-align: center; vertical-align: middle;"> {{element.modalidade}} </td>
                </ng-container>

                <ng-container matColumnDef="papel">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>{{ 'EN4_466.TRANSLATION' | translate }}
                    </th>
                    <td class="columns-result" style="text-align: center;" mat-cell *matCellDef="let element"> {{element.papel}} </td>
                </ng-container>

                <ng-container matColumnDef="quantidade_acoes_boleta">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>{{ 'EN4_475.TRANSLATION' | translate }}
                    </th>
                    <td class="columns-result" mat-cell *matCellDef="let element"
                        style="text-align: center; vertical-align: middle;"> {{element.quantidade_acoes_boleta}} </td>
                </ng-container>

                <ng-container matColumnDef="qtd_acoes_contrato">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>{{ 'EN4_482.TRANSLATION' | translate }}
                    </th>
                    <td class="columns-result" mat-cell *matCellDef="let element"
                        style="text-align: center; vertical-align: middle;"> {{element.qtd_acoes_contrato}} </td>
                </ng-container>

                <ng-container matColumnDef="data_pregao">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>{{ 'EN4_476.TRANSLATION' | translate }}
                    </th>
                    <td class="columns-result" style="text-align: center;"mat-cell *matCellDef="let element"> {{element.data_pregao}} </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>Status</th>
                    <td class="columns-result" style="text-align: center;"mat-cell *matCellDef="let element"> {{element.status_descricao}} </td>
                </ng-container>

                <ng-container matColumnDef="valor_taxa_cliente">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>{{ 'EN4_477.TRANSLATION' | translate }}
                    </th>
                    <td class="columns-result" mat-cell *matCellDef="let element"
                        style="text-align: center; vertical-align: middle;"> {{element.valor_taxa_cliente}} </td>
                </ng-container>

                <ng-container matColumnDef="percentual_taxa_cliente">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>{{ 'EN4_478.TRANSLATION' | translate }}
                    </th>
                    <td class="columns-result" mat-cell *matCellDef="let element"
                        style="text-align: center; vertical-align: middle;"> {{element.percentual_taxa_cliente}} </td>
                </ng-container>

                <ng-container matColumnDef="valor_taxa_corretora">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>{{ 'EN4_479.TRANSLATION' | translate }}
                    </th>
                    <td class="columns-result" mat-cell *matCellDef="let element"
                        style="text-align: center; vertical-align: middle;"> {{element.valor_taxa_corretora}} </td>
                </ng-container>

                <ng-container matColumnDef="percentual_taxa_corretora">
                    <th class="columns-header" style="text-align: center;" mat-header-cell *matHeaderCellDef>{{ 'EN4_480.TRANSLATION' | translate }}
                    </th>
                    <td class="columns-result" mat-cell *matCellDef="let element"
                        style="text-align: center; vertical-align: middle;"> {{element.percentual_taxa_corretora}} </td>
                </ng-container>


                <ng-container matColumnDef="CheckedBox_Corretora_Cliente">
                    <th class="columns-header-checkbox" style="text-align: lefth; vertical-align: small;" mat-header-cell
                        *matHeaderCellDef>
                        <mat-checkbox id="idCheckAllCliente" name="CheckAllCliente" class="checkbox-margin"
                            [(ngModel)]="checkHeaderCliente" (change)="checkAll($event)">
                            {{ 'EN4_481.TRANSLATION' | translate }}
                        </mat-checkbox>
                        <mat-checkbox id="idCheckAllCorretora" name="CheckAllCorretora" class="checkbox-margin"
                            [(ngModel)]="checkHeaderCorretora" (change)="checkAll($event)">
                            {{ 'EN4_465.TRANSLATION' | translate }}
                        </mat-checkbox>
                    </th>
                    <td class="columns-result" mat-cell *matCellDef="let element">
                        <section style="text-align: lefth; vertical-align: small;">
                            <mat-checkbox name="Nao" class="checkbox-margin" [(ngModel)]="element.checked_cliente"
                                (change)="vldCheckBox($event,element)" [disabled]="disableCheckBox(element)"
                                [checked]="Checkedelement('Nao',element)">
                                {{ 'EN4_481.TRANSLATION' | translate }}
                            </mat-checkbox>
                            <mat-checkbox name="Sim" class="checkbox-margin" [(ngModel)]="element.checked_corretora"
                                (change)="vldCheckBox($event,element)" [disabled]="disableCheckBox(element)"
                                [checked]="Checkedelement('Sim',element)">
                                {{ 'EN4_465.TRANSLATION' | translate }}
                            </mat-checkbox>
                        </section>
                    </td>
                </ng-container>

                <tr style="text-align: center;" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>

        <div class="table-footer">
            <mat-paginator id="resultPaginator" [pageIndex]="pageIndex" [pageSizeOptions]="pageSizeOptions"
                (page)="handlePage($event)" class="content-gray table-footer-paginator">
            </mat-paginator>
        </div>
    </div>
